import React, { useState, useContext, useEffect, useRef } from "react";
import { AppContext } from "../../context/AppContext";
import "../../assets/css/myAttendence.scss";
import ReactPaginate from "react-paginate";
import Laptop from "../../assets/images/laptop.svg";
import Android from "../../assets/images/android.svg";
import Apple from "../../assets/images/apple.svg";
import Wifi from "../../assets/images/wifi.svg";
import ic_search_dark from "../../assets/images/ic_search_dark.svg";
import searchicon from "../../assets/images/ic_search.svg";
import { PostCallWithErrorResponse, simpleGetCallWithToken } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { json, Link } from "react-router-dom";
import moment from "moment";
import Loader from "../Loader";
import ic_excel from "../../assets/images/ic_excel.svg";
import FileSaver from "file-saver";
import ExcelLoader from "../../sharedComponent/ExcelLoader";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { MapContainer, TileLayer, useMap, Marker, Popup, LayerGroup, Circle } from 'react-leaflet'
import L from 'leaflet';
import location from "../../assets/images/mapLocation.svg"
import DisplayPunchInSession from "../../component/displayPumcinSession";



const DevicePunchHistory = () => {
  const { sidebar, setSidebar, Dark, setDark, userData } =
    useContext(AppContext);
  const [punchHistory, setPunchHistory] = useState([]);
  const [filteredPunchHistory, setFilteredPunchHistory] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false)
  const position = [19.8872735, 75.3683881]
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState({
    search: moment(new Date()).format("MM/DD/YYYY"),
    OrgId: Number(userData.OrgId),
    LocationID: Number(userData?.locationId),
  });

  const [punchSessionId, setpunchSessionId] = useState(null);

  const [locationList, setLocationList] = useState([]);
  const [selectLocation, setSelectLocation] = useState("")
  const [isCheckin, setisCheckin] = useState(false)
  const locationPostion = useRef()
  const outTimeLocation = useRef()
  const rediusArea = useRef()

  const customIcon = L.icon({
    iconUrl: location,
    iconSize: [38, 38],
    iconAnchor: [19, 38],
    popupAnchor: [0, -38],
  });
  const fillBlueOptions = { fillColor: 'blue' }

  const [excelLoading, setExcelLoading] = useState(false);

  const downloadExcelFile = (e) => {
    setExcelLoading(true);
    let payload = {
      search: moment(new Date()).format("MM/DD/YYYY"),

    };
    e.preventDefault();
    PostCallWithErrorResponse(
      ApiConfig.PUNCH_HISTORY_EXPORT,
      JSON.stringify(payload)
    )
      .then((res) => {
        console.log("Download File Response", res);
        if (res.error) {
          console.log("Error response", res);
        } else {
          if (res.json.Success === true) {
            setExcelLoading(false);
            let data = res.json.Data;
            FileSaver.saveAs(
              "data:" + data.ContentType + ";base64," + data.FileContents,
              data.FileDownloadName
            );
          } else {
            console.log("res", res);
            setExcelLoading(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setLoading(true);
    PostCallWithErrorResponse(ApiConfig.PUNCH_HISTORY_WITH_SESSION, JSON.stringify(body))
      .then((res) => {
        console.log(res);

        if (res.json.Success === true) {
          setPunchHistory(res.json?.Data ? res.json?.Data : []);

        } else {
          setPunchHistory([])
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [body]);

  useEffect(() => {
    const filteredData =
      punchHistory &&
      punchHistory?.filter((item) =>
        item.FullName.toLowerCase().includes(searchValue.toLowerCase())
      );
    setFilteredPunchHistory(filteredData);
  }, [searchValue, punchHistory]);

  const fetchLocations = () => {
    // setLoading(true);
    simpleGetCallWithToken(ApiConfig.GET_MANAGE_LOCATION)
      .then((res) => {
        if (res.Success === true) {
          // setLoading(false);
          setLocationList(res.Data);
        }
        console.log(res.Data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchLocations();
  }, [])

  const handlePunchOutData = (item) => {
    setisCheckin(false)
    setOpen(true)
    console.log("Lan or Log location>>>>", item)
    locationPostion.current = [item?.OutTimeLat, item?.OutTimeLong]
    outTimeLocation.current = item.OutTimeLocation
    rediusArea.current = item?.Radius

  }
  const handlePunchInData = (item) => {
    setisCheckin(true)
    setOpen(true)
    locationPostion.current = [item?.InTimeLat, item?.InTimeLong]
    outTimeLocation.current = item?.InTimeLocation
    rediusArea.current = item?.Radius
    console.log("Punch in data>>>>>", item)
  }
  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content-main">
          <div className="sub-header-role">
            <h6 className="mt-2">Attendance History</h6>
          </div>
          <div className="d-flex justify-content-between role-searchbar-and-btns RspSalary">
            <div className="role-table-header">
              <div className="search-input-wrapper  mb-2 ">

                <input
                  type="text"
                  placeholder="Search Name"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                />
                {Dark === "lightMode" ? (
                  <img src={searchicon} alt="" />
                ) : (
                  <img src={ic_search_dark} alt="" />
                )}

                <div className="ml-5">
                  <input
                    type="date"
                    data-date=""
                    data-date-format="DD MMMM YYYY"
                    placeholder="Search"
                    onChange={(e) => {


                      setBody({
                        ...body,
                        search: e.target.value ? moment(e.target.value).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY"),
                      });

                      // ;
                      // setDate({
                      //   date: dataFun(e.target.value),
                      // });
                    }}

                  />
                </div>


                {/* {Dark === "lightMode" ? (
                  <img src={searchicon} alt="" />
                ) : (
                  <img src={ic_search_dark} alt="" />
                )} */}

              </div>
              <Form.Group className="col-md-2 mt-4 ml-2 w-4" >
                <Form.Select
                  className="form-control tasKCategory1 w-5"
                  required
                  value={body.LocationID}
                  onChange={(e) => {
                    setBody({
                      ...body,
                      LocationID: Number(e.target.value),
                    });
                  }}


                >
                  <option disabled value={""}>
                    Select{" "}
                  </option>
                  {locationList.map((leave) => {
                    return (
                      <option value={leave?.LocationId}>
                        {leave?.LocationName}
                      </option>
                    );
                  })}
                </Form.Select>
              </Form.Group>
              {/* <div className=" ml-2 mt-4"> */}

              {/* </div> */}

              {/* <div className="entries-wrapper">
                <p>Entries per page</p>
                <select
                  className="form-select select-drop-icon"
                  aria-label="Default select example"
                >
                  <option selected>10</option>
                  <option value="1">20</option>
                  <option value="2">10</option>
                  <option value="3">5</option>
                </select>
              </div> */}
            </div>
            <div>
              <div className="import-export-btn-wrapper mt-4">
                <button >
                  {excelLoading ? (
                    <ExcelLoader />
                  ) : (
                    <img
                      src={ic_excel}
                      onClick={(e) => downloadExcelFile(e)}
                      alt=""
                    />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* <div className='emptyPage'>
                        <img src={emptypage} alt="" />
                    </div> */}
          <div className="table-wrapper-main mb-4">
            {loading ? (
              <Loader />
            ) : (
              <>
                <table>
                  <thead>
                    <tr className="firstTabelRow">
                      <th></th>
                      <th>Sr. no</th>
                      <th>Employee Name</th>
                      <th>Check In Device</th>
                      <th>Check Out Device</th>
                    </tr>
                  </thead>

                  {filteredPunchHistory && filteredPunchHistory?.length > 0 ? (
                    filteredPunchHistory?.map((punch, index) => {
                      return (
                        <tbody>
                          <tr className="table-row-main" key={"4+sdf" + index}>
                            <td
                              style={{ cursor: 'pointer', textAlign: 'center', color: '#53B7E8' }}
                              onClick={() => {
                                if (punch?.PunchBreakdown?.length > 0) {
                                  setpunchSessionId(punchSessionId == index ? null : index);
                                }
                              }}
                            >
                              {punch?.PunchBreakdown?.length > 0 && (
                                <span>{punchSessionId === index ? '▲' : '▼'}</span>
                              )}
                            </td>
                            <td> {index + 1} </td>
                            <td> {punch.FullName}</td>
                            <td>
                              <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                  <img
                                    src={
                                      punch.PlatFormId == "1"
                                        ? Laptop
                                        : punch.PlatFormId == "2"
                                          ? Android
                                          : punch.PlatFormId == "3"
                                            ? Apple
                                            : punch.PlatFormId == "4"
                                              ? Wifi
                                              : Wifi
                                    }
                                    alt=""
                                  />
                                  <div className="mx-2">
                                    <label htmlFor="">
                                      {punch.PlatFormId == "1" ? (
                                        <> Browser </>
                                      ) : punch.PlatFormId == "2" ? (
                                        <>Android</>
                                      ) : punch.PlatFormId == "3" ? (
                                        <>IOS</>
                                      ) : punch.PlatFormId == "4" ? (
                                        <>Wifi-Direct</>
                                      ) : (
                                        <>Wifi-Direct</>
                                      )}
                                    </label>

                                  </div>
                                  <div className="mx-1">
                                    <label htmlFor=""> {punch.InTime} </label>
                                  </div>
                                </div>
                              </div>
                            </td>


                            <td>
                              <div className="d-flex justify-content-between">
                                <div className="d-flex">
                                  <img
                                    src={
                                      punch.OutPlatFormId == "0"
                                        ? ""
                                        : punch.OutPlatFormId == "1"
                                          ? Laptop
                                          : punch.OutPlatFormId == "2"
                                            ? Android
                                            : punch.OutPlatFormId == "3"
                                              ? Apple
                                              : punch.OutPlatFormId == "4"
                                                ? Wifi
                                                : Wifi
                                    }
                                    alt=""
                                  />
                                  <div className="mx-2">
                                    {punch.OutPlatFormId == "0" ? (
                                      ""
                                    ) : punch.OutPlatFormId == "1" ? (
                                      <> Browser </>
                                    ) : punch.OutPlatFormId == "2" ? (
                                      <>Android</>
                                    ) : punch.OutPlatFormId == "3" ? (
                                      <>IOS</>
                                    ) : punch.OutPlatFormId == "4" ? (
                                      <>Wifi-Direct</>
                                    ) : (
                                      <>Wifi-Direct</>
                                    )}
                                  </div>
                                  <div className="mx-2">

                                    <label htmlFor="">
                                      {punch.OutTime}

                                    </label>
                                    {punch?.PunchBreakdown?.length > 0 && (
                                      <span
                                        style={{
                                          cursor: 'pointer',
                                          backgroundColor: '#EEF8FD',
                                          border: '1px solid #53B7E8',
                                          borderRadius: '12px',
                                          padding: '2px 8px',
                                          fontSize: '10px',
                                          color: '#53B7E8',
                                          marginLeft: '8px',
                                          fontWeight: 500,
                                          display: 'inline-block',
                                        }}
                                        onClick={() => setpunchSessionId(punchSessionId == index ? null : index)}
                                      >
                                        {punch?.PunchBreakdown?.length} Sessions
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>

                            </td>

                          </tr>
                          {
                            punchSessionId === index && (
                              <DisplayPunchInSession punchBreakDown={punch?.PunchBreakdown || []}
                                handlePunchOutData={handlePunchOutData}
                                handlePunchInData={handlePunchInData}
                              />
                            )
                          }
                        </tbody>
                      );
                    })
                  ) : (
                    <tr className="ErrorDataNotFound">
                      <td colSpan={6}>Data Not Found</td>
                    </tr>
                  )}
                </table>{" "}
              </>
            )}
          </div>
        </div>
      </div>
      <div>

      </div>
      <Modal
        Modal
        size="md"
        show={open}
        onHide={() => setOpen(false)}
        centered

      >

        <Modal.Header closeButton>
          <Modal.Title>{isCheckin ? "Check In Location" : "Check Out Location"}</Modal.Title>
        </Modal.Header>
        <div className="lineSeperate"></div>
        <Modal.Body>
          <div style={{ height: '100%', width: '100%' }}>

            <MapContainer center={locationPostion.current} zoom={13} scrollWheelZoom={true} style={{ height: '300px', width: '480px' }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {
                outTimeLocation.current === "From Office" ? (
                  <>
                    <LayerGroup>
                      <Circle
                        center={locationPostion.current}
                        pathOptions={fillBlueOptions}
                        radius={rediusArea.current}
                      />
                      <Marker position={locationPostion.current} icon={customIcon} >
                        <Popup>
                          {outTimeLocation.current}
                        </Popup>
                      </Marker>
                    </LayerGroup>
                  </>
                ) : (
                  <>
                    <Marker position={locationPostion.current} icon={customIcon} >
                      <Popup>
                        {outTimeLocation.current}
                      </Popup>
                    </Marker>
                  </>
                )
              }


            </MapContainer>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default DevicePunchHistory;
